import { createSlice } from '@reduxjs/toolkit';
import { defaultState } from './data/BuySensorState';

const slice = createSlice({
  name: 'buy-sensor',
  initialState: defaultState,
  reducers: {
    toggleModalOpen: (state) => {
      state.isModalOpen = !state.isModalOpen;
    },
  },
});

export const { toggleModalOpen } = slice.actions;
export default slice.reducer;
